import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { Attachment, AttachmentOwnerType } from '../../../types/Attachment';

const fetchAttachments = async (type: AttachmentOwnerType, uuid: string) => {
  const response = await CustomAxios.get<Attachment[]>(`attachments`, { params: { type, uuid } });
  const { data } = response;
  return data;
};

interface IUseGetAttachmentsByOwnerProps {
  type: AttachmentOwnerType;
  uuid: string;
  enabled?: boolean;
}

export function useGetAttachmentsByOwner({ type, uuid, enabled = true }: IUseGetAttachmentsByOwnerProps) {
  const query = useQuery({
    queryKey: [queryKeys.allAttachments, type, uuid],
    queryFn: () => fetchAttachments(type, uuid),
    enabled,
  });

  return query;
}
